import React, { useState } from "react";
import {
  HiCheck,
  HiX,
  HiOutlineExternalLink,
  HiOutlineEye,
  HiOutlineSparkles,
  HiOutlineChatAlt2,
} from "react-icons/hi";
import ModalDocumento from "./ModalDocumento";
import ModalConfirmacion from "./ModalConfirmacion";
import PanelIA from "./PanelIA";
import "../styles.css";

function obtenerEnlacePrincipal(licitacion) {
  let enlace = null;
  const raw = licitacion.enlaces;
  if (Array.isArray(raw)) {
    const items = raw
      .filter((s) => s?.trim())
      .flatMap((s) => {
        const results = [];
        const regex = /\[?([^\]]+)\]\(([^)"]+)\)/g;
        let m;
        while ((m = regex.exec(s)) !== null)
          results.push({ tipo: m[1].trim(), url: m[2].trim() });
        return results.length ? results : [{ tipo: "Documento", url: s }];
      });
    const encontrado = items.find((i) =>
      i.tipo.toLowerCase().includes("anuncio")
    );
    if (encontrado) enlace = encontrado.url;
    else if (items.length > 0) enlace = items[0].url;
  } else if (typeof raw === "string" && raw.trim()) {
    const items = raw
      .split("|")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    const encontrado = items.find((i) => i.toLowerCase().includes("anuncio"));
    if (encontrado) {
      const parts = encontrado.split(";");
      enlace = parts.length > 1 ? parts[1].trim() : parts[0].trim();
    } else if (items.length > 0) {
      const parts = items[0].split(";");
      enlace = parts.length > 1 ? parts[1].trim() : parts[0].trim();
    }
  }
  return enlace;
}

function PendienteCard({
  licitacion,
  seleccionado = false,
  onToggleSelect,
  onAceptar,
  onRechazar,
  usuario,
  onActualizar,
}) {
  const [expandido, setExpandido] = useState(false);
  const [modalDocsOpen, setModalDocsOpen] = useState(false);
  const [showConfirmRechazar, setShowConfirmRechazar] = useState(false);
  const [procesandoAceptar, setProcesandoAceptar] = useState(false);
  const [procesandoRechazar, setProcesandoRechazar] = useState(false);
  const [mostrarIA, setMostrarIA] = useState(false);
  const [tabIA, setTabIA] = useState("resumen");

  const formatearFecha = (fechaObj) => {
    if (!fechaObj) return "-";
    const d = new Date(fechaObj);
    return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${d.getFullYear()}`;
  };

  const formatearPresupuesto = (valor) => {
    if (valor == null) return "-";
    return (
      new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valor) + " €"
    );
  };

  const handleAceptarClick = async (e) => {
    e.stopPropagation();
    if (procesandoAceptar) return;
    setProcesandoAceptar(true);
    try {
      await onAceptar(licitacion.numero_expediente);
    } finally {
      setProcesandoAceptar(false);
    }
  };

  const handleRechazarClick = (e) => {
    e.stopPropagation();
    setShowConfirmRechazar(true);
  };

  const handleConfirmarRechazo = async () => {
    setShowConfirmRechazar(false);
    if (procesandoRechazar) return;
    setProcesandoRechazar(true);
    try {
      await onRechazar(licitacion.numero_expediente);
    } finally {
      setProcesandoRechazar(false);
    }
  };

  const handleAbrirIA = (e, tab = "resumen") => {
    if (e && e.stopPropagation) e.stopPropagation();
    setExpandido(true);
    if (mostrarIA && tabIA === tab) {
      setMostrarIA(false);
    } else {
      setTabIA(tab);
      setMostrarIA(true);
    }
  };

  return (
    <>
      <div
        className={`licitacion-card card-pendiente ${
          seleccionado ? "seleccionada" : ""
        }`}
      >
        <div
          className="fila-licitacion fila-pendiente"
          onClick={() => setExpandido(!expandido)}
        >
          <div
            className="col-checkbox"
            onClick={(e) => {
              e.stopPropagation();
              onToggleSelect(licitacion.numero_expediente);
            }}
          >
            <input
              type="checkbox"
              checked={seleccionado}
              onChange={() => {}}
            />
          </div>

          <div className="col-expediente">
            {licitacion.numero_expediente.toUpperCase()}
          </div>

          <div className="col-titulo" title={licitacion.titulo}>
            {licitacion.titulo}
          </div>

          <div className="col-organismo" title={licitacion.organismo}>
            {licitacion.organismo}
          </div>

          <div className="col-presupuesto">
            {formatearPresupuesto(licitacion.presupuesto)}
          </div>

          <div className="col-fecha">
            <span className="fecha-limite">
              {formatearFecha(licitacion.fecha_presentacion)}
            </span>
          </div>

          <div className="col-acciones-triaje">
            <button
              className="btn-accion-icono btn-accion-aceptar"
              onClick={handleAceptarClick}
              disabled={procesandoAceptar}
              title="Aceptar licitación"
            >
              <HiCheck size={18} />
            </button>
            <button
              className="btn-accion-icono btn-accion-rechazar"
              onClick={handleRechazarClick}
              disabled={procesandoRechazar}
              title="Rechazar licitación"
            >
              <HiX size={18} />
            </button>
          </div>
        </div>

        {expandido && (
          <div className="detalle-licitacion animate-fadeIn">
            <div className="info-grid">
              <div className="info-item">
                <label>Expediente</label>
                <span>{licitacion.numero_expediente.toUpperCase()}</span>
              </div>
              <div className="info-item">
                <label>BOE</label>
                <span>{formatearFecha(licitacion.boe)}</span>
              </div>
              <div className="info-item">
                <label>Ámbito</label>
                <span>{licitacion.ambito || "-"}</span>
              </div>
              <div className="info-item">
                <label>Presupuesto</label>
                <span className="presupuesto-highlight">
                  {formatearPresupuesto(licitacion.presupuesto)}
                </span>
              </div>
              <div className="info-item">
                <label>País</label>
                <span>{licitacion.pais || "-"}</span>
              </div>
              <div className="info-item">
                <label>Fecha Límite</label>
                <span>{formatearFecha(licitacion.fecha_presentacion)}</span>
              </div>
              <div className="info-item full-width">
                <label>Título</label>
                <span>{licitacion.titulo || "-"}</span>
              </div>
              <div className="info-item full-width">
                <label>Observaciones / Requisitos</label>
                <span>{licitacion.observaciones || "-"}</span>
              </div>
            </div>

            <div className="detalle-sections">
              <div className="section-enlaces">
                <label>
                  <HiOutlineExternalLink /> Enlaces de Interés / Pliegos
                </label>
                <div className="enlaces-list">
                  {(() => {
                    const raw = licitacion.enlaces;
                    let items = [];
                    if (Array.isArray(raw)) {
                      items = raw
                        .filter((s) => s?.trim())
                        .flatMap((s) => {
                          const results = [];
                          const regex = /\[?([^\]]+)\]\(([^)"]+)\)/g;
                          let m;
                          while ((m = regex.exec(s)) !== null)
                            results.push(`${m[1].trim()};${m[2].trim()}`);
                          return results.length ? results : [s];
                        });
                    } else if (typeof raw === "string" && raw.trim()) {
                      items = raw
                        .split("|")
                        .map((s) => s.trim())
                        .filter((s) => s.length > 0);
                    }

                    if (!items.length)
                      return (
                        <span className="no-data">
                          No hay enlaces disponibles
                        </span>
                      );

                    return items.map((item, idx) => {
                      const [tipoRaw, urlRaw] = String(item).split(";", 2);
                      const tipo = tipoRaw.trim() || "Documento";
                      const url = urlRaw?.trim();
                      if (!url) return null;
                      return (
                        <a
                          key={idx}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="enlace-card"
                        >
                          <HiOutlineExternalLink /> {tipo}
                        </a>
                      );
                    });
                  })()}
                </div>
              </div>

              <div className="section-gestion">
                <label>Gestión y Análisis IA</label>
                <div className="botones-acciones-gestion">
                  <button
                    className="btn-gestion"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalDocsOpen(true);
                    }}
                  >
                    <HiOutlineEye /> Ver Documentos
                  </button>
                  <button
                    className={`btn-gestion btn-ia-sparkle ${
                      mostrarIA && tabIA === "resumen" ? "activo" : ""
                    }`}
                    onClick={(e) => handleAbrirIA(e, "resumen")}
                  >
                    <HiOutlineSparkles size={17} /> Resumen IA
                  </button>
                  <button
                    className={`btn-gestion btn-ia-chat ${
                      mostrarIA && tabIA === "chat" ? "activo" : ""
                    }`}
                    onClick={(e) => handleAbrirIA(e, "chat")}
                  >
                    <HiOutlineChatAlt2 size={17} /> Chat Pliegos
                  </button>
                </div>
              </div>
            </div>

            {mostrarIA && (
              <div className="estudio-container animate-fadeIn">
                <PanelIA
                  numeroExpediente={licitacion.numero_expediente}
                  enlaceDefecto={obtenerEnlacePrincipal(licitacion)}
                  tabInicial={tabIA}
                  onCerrar={() => setMostrarIA(false)}
                  onActualizarDocumentos={onActualizar}
                />
              </div>
            )}
          </div>
        )}
      </div>

      <ModalConfirmacion
        visible={showConfirmRechazar}
        titulo="Rechazar Licitación"
        mensaje={`¿Estás seguro de que deseas rechazar el expediente ${licitacion.numero_expediente.toUpperCase()}? Se marcará como rechazada y se mantendrá oculta de las listas.`}
        tipo="rojo"
        onConfirmar={handleConfirmarRechazo}
        onCancelar={() => setShowConfirmRechazar(false)}
      />

      {modalDocsOpen && (
        <ModalDocumento
          numero={licitacion.numero_expediente}
          onClose={() => setModalDocsOpen(false)}
          usuario={usuario}
          onAbrirPanelIA={(tab) => {
            setExpandido(true);
            setTabIA(tab || "resumen");
            setMostrarIA(true);
          }}
        />
      )}
    </>
  );
}

export default PendienteCard;
